import $ from 'jquery';
import Swiper from 'swiper/bundle';
import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded';

imagesLoaded.makeJQueryPlugin($);

if ($('.history-block-isotope').length) {
    const iso = new Isotope('.history-block-isotope', {
        percentPosition: true,
        layoutMode: 'masonry',
        masonry: {
            columnWidth: '.history-block-item-sizer',
        },
    });

    $('.history-block-isotope').imagesLoaded(function () {
        iso.layout();
    });

    const slider = new Swiper('.history-block-slider-wrapper', {
        slidesPerView: 1,
        spaceBetween: 0,
        initialSlide: 1,
        navigation: {
            nextEl: '.history-block-next',
            prevEl: '.history-block-prev',
        },
        on: {
            slideChangeTransitionStart: function (ins) {
                const current = ins.slides[ins.activeIndex];
                const $current = $(current);
                const target = $current.attr('data-filter');
                iso.arrange({ filter: target });
            },
        },
    });

    $(document).on('click', '.history-block-slider-item', function () {
        const index = $(this).index();
        slider.slideTo(index);
    });
}
